module.exports = __webpack_public_path__ + "img/xt13@2x.dfe0f988.png";